/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

//Cookies
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString() + ";";
  if(exdays ==0){ expires = ''; }//Brtwoser fix: when expire set to zero some browsers don't create cookie so expires should be omitted for session cookie
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

//Check for 'cookies-accepted' cookie
var cookies_accepted = getCookie("cookies-accepted");
if (cookies_accepted == "") {
  document.body.classList.toggle("cookies"); //No cookie then show cookies-accept bar
}

//Querystring
var query_string = (function(a) {
    if (a == "") return {};
    var b = {};
    for (var i = 0; i < a.length; ++i)
    {
        var p=a[i].split('=', 2);
        if (p.length == 1)
            b[p[0]] = "";
        else
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
    }
    return b;
})(window.location.search.substr(1).split('&'));

//Listener for ACCEPT button
var accept_cookies_button = document.getElementById("accept-cookies");
if(typeof(accept_cookies_button) != 'undefined' && accept_cookies_button != null){
  accept_cookies_button.onclick = function(e) { e.preventDefault(); coookiesAccept(); };
}
function coookiesAccept() {
  setCookie("cookies-accepted", "true", 0); //Set cookie for 'cookies-accepted'
  document.body.classList.toggle("cookies"); //Remove class from body tag to hide cookies bar
}

//Listener for cart accept terms and conditions
document.addEventListener('click', function (event) {
    if ( event.target.getAttribute('name') === 'checkout' || event.target.getAttribute('name') === 'goto_pp'  || event.target.getAttribute('name') === 'goto_gc' ) {
        // Do something...
        if(document.getElementById("agree").checked === true){
        }else{
        	alert("You must agree with the terms and conditions of sales to check out.");
        	event.preventDefault();
        }
    }
}, false);

//Product Carousel
var product_carousel = document.getElementById("ProductCarousel");
if(typeof(product_carousel) != 'undefined' && product_carousel != null){
  var flkty = new Flickity('#ProductCarousel .ProductCarousel', {
      cellSelector: '.ProductCarousel__Cell',
      pageDots: false,
      freeScroll : true,
      draggable: true,
      cellAlign: 'left',
      wrapAround: true,
      "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
  });
}

var product_carousel = document.getElementById("ProductCarousel2");
if(typeof(product_carousel) != 'undefined' && product_carousel != null){
  var flkty = new Flickity('#ProductCarousel2 .ProductCarousel', {
      cellSelector: '.ProductCarousel__Cell',
      pageDots: false,
      freeScroll : true,
      draggable: true,
      cellAlign: 'left',
      wrapAround: true,
      "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
  });
}

//Collection filter
var collection_filter = document.getElementById("collection-filter");
if(typeof(collection_filter) != 'undefined' && collection_filter != null){
  
  //Check for sort_by querystring parameter
  var sort_by = query_string["sort_by"];
  if(typeof(sort_by) != 'undefined' && sort_by != null){
    select_element('collection-filter', sort_by);
    function select_element(id, val) {    
        let element = document.getElementById(id);
        element.value = val;
    }
   }
  
  //Listener for collection filter dropdown list
  collection_filter.addEventListener("change", function(){
    let url = window.location.href.split('?')[0];
    let filter = this.value;
    window.location = url+'?sort_by='+filter;
  });
  
}

//Listener for collection filter button
var filter_btn = document.getElementById("filter-btn");
if(typeof(filter_btn) != 'undefined' && filter_btn != null){
  filter_btn.onclick = function(e) { e.preventDefault(); toggle_filter(); };
}
//Listener for collection filter close button
var filter_close_btn = document.getElementsByClassName("filter__close")[0];
if(typeof(filter_close_btn) != 'undefined' && filter_close_btn != null){
  filter_close_btn.onclick = function(e) { e.preventDefault(); toggle_filter(); };
}
function toggle_filter() {
  document.documentElement.classList.toggle("no-scroll"); //Toggle no-scroll to html tag
  let page_overlay = document.getElementsByClassName("PageOverlay")[0];
  page_overlay.classList.toggle("is-visible");
  let collection_filter_overlay = document.getElementsByClassName("collection-filter-overlay")[0];
  collection_filter_overlay.classList.toggle("is-visible");
}

//Listener for back to top
var back_to_top_btn = document.getElementById("back-to-top");
if(typeof(back_to_top_btn) != 'undefined' && back_to_top_btn != null){
  back_to_top_btn.onclick = function(e) { 
    e.preventDefault(); 
    //document.body.scrollTop = document.documentElement.scrollTop = 0;
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: 0
    });
  };
}

//Listener for PageOverlay
var page_overlay = document.getElementsByClassName("PageOverlay")[0];
if(typeof(page_overlay) != 'undefined' && page_overlay != null){
  page_overlay.onclick = function(e) { 
    e.preventDefault();
    var search_bar = document.getElementById("Search");
    if(search_bar.getAttribute('aria-hidden') == 'false'){ 
      let search_close = document.getElementsByClassName("Search__Close")[0];
  	  search_close.click();
    }
  };
}


////Listen search bar icon .search-bar-icon
var search_button = document.getElementsByClassName("search-bar-icon")[0];
if(typeof(search_button) != 'undefined' && search_button != null){
  search_button.onclick = function(e) { 
    document.querySelectorAll('.HorizontalList__Item.is-expanded').forEach(function (item) {item.classList.remove('is-expanded');});
    document.querySelectorAll('.MegaMenu').forEach(function (item) {item.setAttribute('aria-hidden', true);});
  };
}

////Scroll
window.onscroll = function() { scroll_check() };
window.onload = function () { scroll_check() };
function scroll_check() {
  if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
    document.body.classList.add("sticky");
  } else {
    document.body.classList.remove("sticky");
  }
  var back_to_top_btn = document.getElementById("back-to-top");
  if (document.body.scrollTop > 10 || document.documentElement.scrollTop > 10) {
    back_to_top_btn.classList.add("reveal");
  } else {
    back_to_top_btn.classList.remove("reveal");
  }
}

//Recently viewed products
//alert(localStorage.getItem('recentlyViewedProducts'));


//Sort popup
//Popover__ValueList
function reverseChildren(parent) {
    for (var i = 1; i < parent.childNodes.length; i++){
        parent.insertBefore(parent.childNodes[i], parent.firstChild);
    }
}
var sort_list = document.getElementsByClassName("Popover__ValueList")[0];
if(typeof(sort_list) != 'undefined' && sort_list != null){
  //reverseChildren(sort_list);
}

//var flkty = new Flickity( '.ProductCarousel', { draggable: true });

// Snow JavaScript
class SnowItem {
  constructor(canvas, ctx, options) {
    const { radius, speed, wind, color } = options;

    this.params = {
      color,
      x: Math.random() * canvas.offsetWidth,
      y: -Math.random() * 200 - 20,
      radius: randomRange(radius[0], radius[1]),
      speed: randomRange(speed[0], speed[1]),
      wind: randomRange(wind[0], wind[1]),
      isResized: false
    };

    this.canvas = canvas;
    this.ctx = ctx;
  }

  updateData() {
    this.params.x = Math.random() * this.canvas.offsetWidth;
    this.params.y = -Math.random() * 200 - 20;
  }

  translate() {
    this.params.y += this.params.speed;
    this.params.x += this.params.wind;
  }

  onDown() {
    if (this.params.y < this.canvas.offsetHeight) return;

    if (this.params.isResized) {
      this.updateData();
      this.params.isResized = false;
    } else {
      this.params.y = -20;
      this.params.x = Math.random() * this.canvas.offsetWidth;
    }
  }

  resized() {
    this.params.isResized = true;
  }

draw() {
  const { x, y, radius, color } = this.params;
  const ctx = this.ctx;

  // Create a radial gradient for soft snowflake effect
  const gradient = ctx.createRadialGradient(x, y, 0, x, y, radius);
  gradient.addColorStop(0, color);           // center color
  gradient.addColorStop(0.8, color + "80");  // semi-transparent edge
  gradient.addColorStop(1, color + "00");    // fully transparent

  ctx.beginPath();
  ctx.arc(x, y, radius, 0, 2 * Math.PI);
  ctx.fillStyle = gradient;
  ctx.fill();
  ctx.closePath();

  // Optional: simple 4-line flake "arms"
  ctx.beginPath();
  ctx.moveTo(x - radius, y);
  ctx.lineTo(x + radius, y);
  ctx.moveTo(x, y - radius);
  ctx.lineTo(x, y + radius);
  ctx.strokeStyle = color + "60"; // light transparent
  ctx.lineWidth = 0.5;
  ctx.stroke();
  ctx.closePath();
}


  update() {
    this.translate();
    this.onDown();
  }
}

// Helper
function randomRange(min, max) {
  return Math.random() * (max - min) + min;
}

